import { useState } from 'react';
export default function useUncontrolledProp(_ref) {
  var {
    prop,
    defaultProp,
    onChange
  } = _ref;
  var isControlled = prop !== undefined;
  var [stateValue, setStateValue] = useState(defaultProp);
  var value = isControlled ? prop : stateValue;
  var onValueChange = (nextValue, e) => {
    !isControlled && setStateValue(nextValue);
    onChange === null || onChange === void 0 ? void 0 : onChange(nextValue, e);
  };
  return [value, onValueChange];
}
//# sourceMappingURL=index.js.map